import client from './client';
import { EnCryptData } from '../util/CustomUtil';

export const getMainBannerList = () => client.get(`/campaign/bn/main`);
export const getEventList = (param) => client.get('/campaign/events' + param);
export const getEventDetail = ({ id }) => client.get(`/campaign/event/${id}`);
export const applyEvent = ({ data }) => {
  let params = new URLSearchParams();
  params.append('data', EnCryptData(JSON.stringify(data)));
  return client.post('/campaign/apply', params);
};
